module.exports = __webpack_public_path__ + "fonts/LidlFontPro-Bold.woff2";